export function maxMessage(max) {
  return `Must be ${max} characters or less`;
}

export { default as Button } from './Button';
export { default as FormField } from './FormField';
export { default as FormStatus } from './FormStatus';
export { default as FormikTemplate } from './FormikTemplate';
